import * as React from "react";
import type { AdminRole } from "@/providers/types";

// Darker text colors on tinted backgrounds to satisfy WCAG 2.2 AA 4.5:1 ratio for small text.
const ROLE_CLASS: Record<AdminRole, string> = {
  superadmin: "bg-[var(--accent-weak)] text-[#1044a0]",
  moderator: "bg-[rgba(196,138,26,0.10)] text-[#7a5200]",
  support: "bg-[rgba(26,138,82,0.08)] text-[#0d6e3e]",
  analyst: "bg-[rgba(0,0,0,0.05)] text-[#5a5a5a]",
};

interface RoleBadgeProps {
  role: AdminRole;
}

export function RoleBadge({ role }: RoleBadgeProps): React.JSX.Element {
  return (
    <span
      className={[
        "inline-block text-[10px] font-[700] uppercase tracking-[0.4px] px-1.5 py-px rounded-[3px] ml-1.5 align-middle",
        ROLE_CLASS[role],
      ].join(" ")}
    >
      {role}
    </span>
  );
}
